import { registerPlugin } from '@capacitor/core'

export interface SaveFileOptions {
  filename: string
  data: string
  mimeType?: string
  isBase64?: boolean
}

export interface SaveFileResult {
  success: boolean
  uri?: string
  cancelled?: boolean
}

interface SaveFilePickerPlugin {
  saveFile(options: SaveFileOptions): Promise<SaveFileResult>
}

const SaveFilePicker = registerPlugin<SaveFilePickerPlugin>('SaveFilePicker')

interface ISaveFilePickerCapacitor {
  saveFile: (options: SaveFileOptions) => Promise<SaveFileResult>
}

export default class SaveFilePickerCapacitor implements ISaveFilePickerCapacitor {
  async saveFile (options: SaveFileOptions): Promise<SaveFileResult> {
    return await SaveFilePicker.saveFile({
      ...options,
      mimeType: options.mimeType || 'application/octet-stream',
      isBase64: options.isBase64 || false
    })
  }
}
